// ⚠️ EDIT THIS: your WhatsApp number in international format (country code + number, no +, spaces or dashes)
export const WHATSAPP_NUMBER = "919761248179";

export const wa = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const MESSAGES = {
  general: "Hi Earth Nest Organics, I'd like to know more about your organic manure and garden care services.",
  p4: "I want to order 4 KG Earth Nest Organics manure for ₹99.",
  p10: "I want to order 10 KG Earth Nest Organics manure for ₹199.",
  p15: "I want to order 15 KG Earth Nest Organics manure for ₹299.",
  feeding: "I want to book Plant Feeding Service. Feeding charge is ₹15/kg.",
  weeding: "I want to book Garden Weeding/Nulai Service. Rate is ₹10/pot or ₹8/sq.ft.",
  orderManure: "Hi Earth Nest Organics, I want to order manure. Please share details.",
  bookService: "Hi Earth Nest Organics, I want to book a garden-care service.",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/db54320a-8966-4b8c-9f9b-611bddac019a/images/de8e268c17f1b9c9c31719fcd1798f64f558f6f0fa76232a6bbf94298d43a9bb.jpeg",
  pack: "https://static.prod-images.emergentagent.com/jobs/db54320a-8966-4b8c-9f9b-611bddac019a/images/5a61f6b1e9a20a343e4b28df38eab706b0fbffe7f54ee3cbd2495365959dfee0.jpeg",
  before: "https://static.prod-images.emergentagent.com/jobs/db54320a-8966-4b8c-9f9b-611bddac019a/images/8f964a335c0ee4bbfd4c58c5ebf48802274253adaa3d5013abd0e3249d610e35.jpeg",
  after: "https://static.prod-images.emergentagent.com/jobs/db54320a-8966-4b8c-9f9b-611bddac019a/images/3111b1723784801f2a22a62950c7050de777955fcd796d7939016a2e565416dc.jpeg",
  feeding: "https://images.unsplash.com/photo-1615346832334-23e27e819c0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  weeding: "https://images.unsplash.com/photo-1611843467160-25afb8df1074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  insp1: "https://images.unsplash.com/photo-1682446904355-00bdf71c1614?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  insp2: "https://images.unsplash.com/photo-1777383504353-77974872c2ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  insp3: "https://images.unsplash.com/photo-1659265390699-cca272bb81c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  insp4: "https://images.unsplash.com/photo-1621459557554-60a70d3d61ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};
